import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./style.module.css";
import HTLPCarouselHeader from "./HTLPCarouselHeader/index";
import HTLPCarouselHeaderDropDown from "./HTLPCarouselHeaderDropDown/index";
import HTLPCarouselContent from "./HTLPCarouselContent";
import { useScrollDirection, useScrollYCoord } from "../../SubscriptionPageV2/hooks";
const HTLPCarouselBody = ({ items, isCheckout }) => {
    const [productData, setProductData] = useState(null);
    const [currentProduct, setCurrentProduct] = useState("");
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const scrollDirection = useScrollDirection();
    const scrollCoord = useScrollYCoord();
    const setProduct = (value) => {
        setCurrentProduct(value);
    };
    const setTabIndex = (value) => {
        setCurrentTabIndex(value);
    };
    const setCurrentProductKey = () => {
        const key = Object.keys(items).length ? Object.keys(items)[0] : "";
        setCurrentProduct(key);
    };
    useEffect(() => {
        if (items && !currentProduct) {
            setProductData(items);
            setCurrentProductKey();
        }
    }, [items]);
    return (_jsxs("div", { className: styles.product_carousel_container, children: [_jsx(CSSTransition, { in: scrollCoord > 210 && scrollDirection === "down", timeout: 500, classNames: "topHeader-bar", children: _jsx(HTLPCarouselHeaderDropDown, { className: "initial-topHeader-bar", currentTabIndex: currentTabIndex, items: items, setCurrentProduct: setProduct, setCurrentTabIndex: setTabIndex }) }), _jsx(HTLPCarouselHeader, { currentTabIndex: currentTabIndex, items: items, setCurrentTabIndex: setTabIndex, setCurrentProduct: setProduct }), _jsx(HTLPCarouselContent, { productData: productData && productData[currentProduct], isCheckout: isCheckout })] }));
};
export default HTLPCarouselBody;
